module.exports = __webpack_public_path__ + "img/008_Employee relations icon.aa519436.png";